import { createFileRoute } from '@tanstack/react-router';
import { GoalMilestonesRouteView } from '@/pages/workspaces/goals/[goalId]/routing';

function GoalMilestonesRoute() {
  const { workspaceId, goalId } = Route.useParams();

  return <GoalMilestonesRouteView workspaceId={workspaceId} goalId={goalId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/goals/$goalId/milestones')({
  component: GoalMilestonesRoute,
});
